import { combineReducers } from 'redux';
import auth from './auth/auth.slice';

export default combineReducers({
  auth,
});
